//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_LISTAS = "obtenerListas";
export const OBTENER_LISTA = "obtenerLista";
export const REGISTRAR_LISTA = "registrarLista";
export const ACTUALIZAR_LISTA = "actualizarLista";

// mutation types
export const SET_LISTAS = "setListas";
export const SET_LISTA = "setLista";

const state = {
    listas: [],
    lista:[],
}

const getters = {
    obtenerListas(state) {
      return state.asesores;
    },
}

const actions = {
    async [OBTENER_LISTAS](context, estadoId) {

        /*
        * Si el estado es 0 va a traer a todos los listas, de lo contrario va a traer los listas por estado
        *
        */
        let endpoint = 'api/Listas'
        if(estadoId>0){
            endpoint = `api/Listas/Estado/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_LISTAS, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    async [OBTENER_LISTA](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Listas/`)
                .then(({ data }) => {
                    context.commit(SET_LISTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },
    async [REGISTRAR_LISTA](context, datos){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Listas`, datos)
                .then(({ data }) => {
                    context.commit(SET_LISTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },
    async [ACTUALIZAR_LISTA](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Listas/`, datos)
                .then(({ data }) => {
                    context.commit(SET_LISTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }
  }

const mutations = {
    [SET_LISTAS](state, data) {
        state.listas = data;
    },

    [SET_LISTA](state, data) {
        state.lista = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}